import React, { useEffect } from "react";
import { useAuthService } from "../../services";
import { useSearchParams } from "react-router-dom";
import { ApiUrl, NotifyType } from "../../util/app-config";
import { notify } from "../../util";

function CorppassLogin() {
  const { createSession, initCorppassAuth } = useAuthService();
  let [searchParam, setSearchPara] = useSearchParams();
  const { message } = notify();

  useEffect(() => {
    const handleNavigate = async () => {
      const session = await createSession(searchParam.get("ut") ?? "", searchParam.get("lt") ?? "");
      if (!session || !session.state || !session.nonce) {
        message(NotifyType.Error, "Unable to create Corppass login session");
        return;
      }

      const initAuthResponse = await initCorppassAuth({
        state: session.state,
        nonce: session.nonce
      }, ApiUrl.CPInitAuth);

      if (initAuthResponse && initAuthResponse.authorizationUrl) {
        window.location.href = initAuthResponse.authorizationUrl;
      } else {
        message(NotifyType.Error, "Unable to initialize Corppass authorization");
      }
    };

    handleNavigate();
  }, []);

  return <div>Redirecting to CorpPass..................</div>;
}

export default CorppassLogin;
